import { render } from "./StarsForm.vue?vue&type=template&id=070669cc&scoped=true"
import script from "./StarsForm.vue?vue&type=script&lang=js"
export * from "./StarsForm.vue?vue&type=script&lang=js"

import "./StarsForm.vue?vue&type=style&index=0&id=070669cc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070669cc"]])

export default __exports__